<template>
  <div class="product-item">
    <div class="title-with-select m-b-10">
      <SfCheckbox
        @change="$emit('change', item)"
        :value="item.selected"
        :selected="item.selected"
        class="title-checkbox"
        name="item"
      />
      <SfHeading
        @click.native="goToProduct(item.Sku)"
        :level="4"
        :description="item.Name"
        :title="item.Sku"
        class="title sf-heading--left"
      />
    </div>
    <SfProperty class="column-property m-b-10" :name="$t('SKU')" :value="item.Sku" />
    <SfProperty class="column-property m-b-10" :name="$t('Qtu')" :value="item.Quantity" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { SfHeading, SfProperty, SfCheckbox } from '@storefront-ui/vue';

export default {
  name: 'ShippingListCartElement',
  components: {
    SfHeading,
    SfProperty,
    SfCheckbox,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToProduct(Sku) {
      this.searchByParts({
        Sku,
        EquipmentList: [],
        VehicleKeyList: [],
      }).then(({ Interpretations, Boards, SimpleProduct }) => {
        this.$router.push({
          name: 'Level4Product',
          params: {
            product: SimpleProduct.Id,
            boards: Boards,
            interpretations: Interpretations,
          },
        });
      });
    },
    ...mapActions({
      searchByParts: 'level4/searchByParts',
    }),
  },
};
</script>

<style scoped type="scss">
.title-with-select {
  display: flex;
  vertical-align: middle;

}

.title-checkbox {
  margin-right: 10px;
  display: flex;
}

.title {
  cursor: pointer;
}

.product-item {
  padding: 20px 10px;
}

.product-item + .product-item {
  border-top: 1px solid var(--c-light);
}

.active,
.product-item:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
